module.exports = __webpack_public_path__ + "img/rx-request.840eddcb.svg";